// 开讲新版
// const liveMessages = require('../page/LiveMessages.user.page');
// const LiveComments = require('../page/LiveComments.page');
const liveMessages = () => import('../page/LiveMessages.user.page');
const LiveComments = () => import('../page/LiveComments.page');

export default [
  // 用户端课堂
  {
    path: '/info/:liveId/messages',
    name: 'liveMessages',
    component: liveMessages,
    meta: {
      pageTitle: '课堂',
      requiresAuth: true,
      authType: 'user'
    }
  },
  // 课程评论
  {
    path: '/info/:liveId/comments',
    name: 'LiveComments',
    component: LiveComments,
    meta: {
      pageTitle: '评价页',
      requiresAuth: true,
      authType: 'user'
    }
  }
];



// WEBPACK FOOTER //
// ./src/user/router/class.js